import {AlertFillIcon, CheckIcon, ExclamationIcon, StackCheckIcon, StackRemoveIcon, XIcon} from '@primer/octicons-react'
import type {StackSectionStatusType} from '../../../helpers/merge-box-status-calculator/stack-section-status'
import CircleOcticon from '@github-ui/circle-octicon'
import {HEADER_ICON_SIZE} from '../../../constants'
import styles from './StatusIcon.module.css'

export function StatusIcon({status}: {status: StackSectionStatusType}) {
  let className
  let Icon
  switch (status) {
    case 'BLOCKED':
    case 'FAILED':
      Icon = XIcon
      className = styles.failed
      break
    case 'PASSED':
      Icon = CheckIcon
      className = styles.passed
      break
    case 'PENDING':
      Icon = ExclamationIcon
      className = styles.pending
      break
    case 'UNKNOWN':
    default:
      Icon = AlertFillIcon
      className = styles.unknown
      break
  }

  return <CircleOcticon className={className} size={HEADER_ICON_SIZE} icon={() => <Icon size={16} />} />
}

export function StackStatusIcon({
  status,
  isFirstUnmergedPRInStack,
}: {
  status: StackSectionStatusType
  isFirstUnmergedPRInStack: boolean
}) {
  let className
  let Icon
  switch (status) {
    case 'BLOCKED':
    case 'FAILED':
      Icon = isFirstUnmergedPRInStack ? XIcon : StackRemoveIcon
      className = styles.failed
      break
    case 'PASSED':
      Icon = isFirstUnmergedPRInStack ? CheckIcon : StackCheckIcon
      className = styles.passed
      break
    case 'PENDING':
      Icon = ExclamationIcon
      className = styles.pending
      break
    default:
      Icon = AlertFillIcon
      className = styles.unknown
      break
  }

  return (
    <CircleOcticon
      className={className}
      size={HEADER_ICON_SIZE}
      icon={() => <Icon size={16} data-testid="stack-status-icon" />}
    />
  )
}
